import React from 'react';
import { S2Icons, S2IconCardProps } from '@milanlaser/mlcomponents';
import { PaddingSize, paddingMap } from '../../utils/builderPaddingOptions';
import { processBackgroundAndGradientColorMap } from '../../../../components/builder/utils/builder.utils';
import { useFirebaseMetrics } from '../../utils/useFirebaseMetrics';

type S2IconsArgs = React.ComponentProps<typeof S2Icons> & {
    iconCount?: number;
    animate?: boolean;
    desktopPaddingTop?: PaddingSize;
    desktopPaddingBottom?: PaddingSize;
    mobilePaddingTop?: PaddingSize;
    mobilePaddingBottom?: PaddingSize;
};

export function S2IconsSection(s2IconProps: S2IconsArgs) {
    const { replaceVariables } = useFirebaseMetrics();
    const {
        desktopPaddingTop = 'large',
        desktopPaddingBottom = 'large',
        mobilePaddingTop = 'small',
        mobilePaddingBottom = 'small',
        ...restProps
    } = s2IconProps;

    const topPaddingClasses = `mcl-pt-${paddingMap[mobilePaddingTop]} lg:mcl-pt-${paddingMap[desktopPaddingTop]}`;
    const bottomPaddingClasses = `mcl-pb-${paddingMap[mobilePaddingBottom]} lg:mcl-pb-${paddingMap[desktopPaddingBottom]}`;

    const processedIcons =
        restProps.icons?.map((icon: S2IconCardProps) => ({
            ...icon,
            headline: replaceVariables(icon.headline),
            description: replaceVariables(icon.description),
            lottieLoopDelay: icon.lottieLoopDelay ?? 0,
        })) || [];

    const processedDescription = replaceVariables(restProps.description);

    const modifiedProps = {
        ...restProps,
        description: processedDescription,
        icons: processedIcons,
        className: `mcl-mx-auto mcl-max-w-7xl ${topPaddingClasses} ${bottomPaddingClasses}`,
    }; // Adding mcl-max-w-7xl to limit the width of the component to match the nav bar for consistency

    //get the background color and gradient color for the wrapper div in builder.
    const backgroundColor = processBackgroundAndGradientColorMap({
        backgroundColor: s2IconProps.backgroundColor || 'default',
        gradientColor: s2IconProps.gradient || 'default',
    });

    return (
        <div className={`${backgroundColor}`}>
            <S2Icons hasDescription={true} {...modifiedProps} />
        </div>
    );
}
